import
  React
from 'react';

import {
  Base,
  HContainer,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../../constants';

export const AccountStatusCard = props => {

  return (

    <VContainer
      padding={props.padding}
      backgroundColor={CustomColors.White}
      margin={props.margin}
      borderRadius={props.borderRadius}
      boxShadow={props.boxShadow}>

      <HContainer
        borderBottom={`1px solid ${CustomColors.Grey4}`}>

        <Text
          fontSize={props.fontSize}
          fontWeight={'bold'}
          lineHeight={'2.44'}
          padding={'3px 0 3px 14px'}
          color={CustomColors.Red1}>

          {props.title}
        </Text>

        <Base
          margin={'auto 12px auto auto'}>

          <Image
            src={Icons.RedCoins}
            width={'23px'}/>
        </Base>
      </HContainer>
    {
      props.isError
        ? <VContainer
            padding={'16px 8px'}>

              <Text textAlign={'center'}>

                {'Something\'s wrong. Please refresh your page or come back later.'}
              </Text>

          </VContainer>
        : <>
            <HContainer
              margin={'24px 0 12px'}>

              <Text
                fontFamily={props.fontFamily}
                fontSize={props.fontSize}
                fontWeight={'bold'}
                padding={'0 14px'}
                color={CustomColors.Grey9}>

                {props.amountLeftText}
              </Text>

              <Base
                margin={'0 0 0 auto'}>

                <Text
                  fontFamily={props.fontFamily}
                  fontSize={props.fontSize}
                  fontWeight={'bold'}
                  padding={'0 10px'}
                  color={CustomColors.Grey9}>

                  {props.amountLeft}
                </Text>
              </Base>
            </HContainer>

            <HContainer
              margin={'0 0 14px 0'}>

              <Text
                fontFamily={props.fontFamily}
                fontSize={props.fontSize}
                padding={'0 14px'}
                color={CustomColors.Grey9}>

                {props.qualifyText}
              </Text>

              <Base
                margin={'0 0 0 auto'}>

                <Text
                  fontFamily={props.fontFamily}
                  fontSize={props.fontSize}
                  padding={'0 10px'}
                  color={CustomColors.Grey9}>

                  {props.qualifyValue}
                </Text>
              </Base>
            </HContainer>
          </>

    }

    </VContainer>
  );
};

AccountStatusCard.defaultProps = {
  padding: '10px',
  title: 'Your account status',
  amountLeftText: 'Advance amount left',
  amountLeft: '',
  qualifyText: 'You qualify for',
  qualifyValue: '',
  fontSize: '16px',
  fontFamily: 'Roboto',
  margin: '',
  borderRadius: '4px',
  boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.15)'
};
